export const categoryOptions = {
  'book': 'Book',
  'research': 'Research Article',
  'course': 'Course',
  'report': 'Report',
  'case_study': 'Case Study',
  'data': 'Dataset',
  'pilot': 'Guideline/Framework',
  'flyer': 'Flyer',
  'news': 'News Article',
  'presentation': 'Presentation',
  'abstract': 'Abstract',
  'phd': 'PhD Thesis',
  'master': 'Master Thesis',
  'bachelor': 'Bachelor Thesis',
  'internship': 'Internship Report',
  'two-pager': 'Two-pager'
}

export const languageOptions = {
  'en': 'English',
  'fr': 'French',
  'es': 'Spanish',
  'pt': 'Portuguese',
  'de': 'German',
  'other': 'Other'
}

export const regionOptions = {
  'world': 'World',
  'europe': 'Europe',
  'africa': 'Africa',
  'asia': 'Asia',
  'north_america': 'Northern America',
  'latam': 'South America ',
  'oceania': 'Oceania',
  'east_africa': 'East Africa',
  'west_africa': 'West Africa',
  'north_africa': 'North Africa',
  'south_africa': 'Southern Africa',
  'central_asia': 'Central Asia and Caucasus',
  'caribbean': 'Latin America & The Caribbean',
  'central_america': 'Central America',
  'south_america': 'South America',
  'middle_east': 'Middle East',
  'south_east_asia': 'Southeast Asia',
  'east_asia': 'East Asia',
  'asia_pacific': 'Asia Pacific',
  'south_asia': 'South Asia',
  'mena': 'Middle East and Northern Africa (MENA)'
}

export const topicOptions = {'microfinance': 'Microfinance',
  'green_mf': 'Green Inclusive Finance',
  'climate_smart_agri': 'Climate-smart agriculture',
  'climate_change_adapt': 'Climate change adaptation',
  'conservation': 'Conservation',
  'energy_access': 'Energy access',
  'energy_efficiency': 'Energy efficiency',
  'energy_poverty': 'Energy poverty',
  'forestry': 'Forestry',
  'green_enterprises': 'Green enterprises',
  'value_chains': 'Value chains',
  'impact_assessment': 'Impact assessment',
  'environmental_performance': 'Environmental performance\u00a0',
  'risk_management': 'Environmental risk management',
  'gender': 'Gender',
  'natural_disasters': 'Natural disasters',
  'poverty_alleviation': 'Poverty alleviation',
  'renewable_energy': 'Renewable energy',
  'sustainable_dev': 'Sustainable development',
  'social_performance': 'Social performance',
  'wash': 'WASH'
}

export const colorsOptions = [
  // Updated maximum of 21 colors
  '#B0BF1A',
  '#0048BA',
  '#E52B50',
  '#FFBF00',
  '#841B2D',
  '#005BB6',
  '#7C0A02',
  '#318CE7',
  '#BD33A4',
  '#00CC99',
  '#E34234',
  '#E4D00A',
  '#9932CC',
  '#483D8B',
  '#8B008B',
  '#00CED1',
  '#DA3287',
  '#00BFFF',
  '#1560BD',
  '#E25822',
  '#0072BB'
]

export const sdgOptions = [
  {
    name: 'SDG1: No Poverty',
    value: '1'
  },
  {
    name: 'SDG2: Zero Hunger',
    value: '2'
  },
  {
    name: 'SDG3: Good Health and Well-being',
    value: '3'
  },
  {
    name: 'SDG4: Quality Education',
    value: '4'
  },
  {
    name: 'SDG5: Gender Equality',
    value: '5'
  },
  {
    name: 'SDG6: Clean Water and Sanitation',
    value: '6'
  },
  {
    name: 'SDG7: Affordable and Clean Energy',
    value: '7'
  },
  {
    name: 'SDG8: Decent Work and Economic Growth',
    value: '8'
  },
  {
    name: 'SDG9: Industry, Innovation, and Infrastructure',
    value: '9'
  },
  {
    name: 'SDG10: Reducing Inequality',
    value: '10'
  },
  {
    name: 'SDG11: Sustainable Cities and Communities',
    value: '11'
  },
  {
    name: 'SDG12: Responsible Consumption and Production',
    value: '12'
  },
  {
    name: 'SDG13: Climate Action',
    value: '13'
  },
  {
    name: 'SDG14: Life Below Water',
    value: '14'
  },
  {
    name: 'SDG15: Life On Land',
    value: '15'
  },
  {
    name: 'SDG16: Peace, Justice, and Strong Institutions',
    value: '16'
  },
  {
    name: 'SDG17: Partnerships for the Goals',
    value: '17'
  }
]



// WEBPACK FOOTER //
// ./src/options.js